import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { Card, Table, Space, Pagination, Button, Input, Form, Modal, Image, message, Checkbox, Avatar, DatePicker, Select } from 'antd'
import { QrcodeOutlined } from '@ant-design/icons';
//import { PlusOutlined, UploadOutlined, QrcodeOutlined } from '@ant-design/icons';
import { getHouseVisitorListAPI, getHouseVisitorQRcodeAPI, getAllFollowUpUserListAPI, allocationCustomerAPI, addHouseVisitorAPI, updateHouseVisitorAPI, configHouseVisitorQRcodeAPI } from '@/apis/user'
import { checkMenu, checkLogin, checkPhone } from '@/utils'
import Dayjs from 'dayjs'
import styles from './customerList.module.scss'
// import { useParams } from 'react-router-dom'
const { Column } = Table
const { TextArea } = Input;

export default function VisitorList() {
  const navigate = useNavigate()
  const location = useLocation()
  const [listLoading, setListLoading] = useState(false) //  表格加载状态
  //  列表请求参数
  const [listQuery, setListQuery] = useState({
    mobile: '',
    channelName: '',
    pageInt: 1,
    pageSize: 10,

  })
  const [total, setTotal] = useState(0) //  列表总数
  const [list, setList] = useState([])
  const sourceTypeList = ['扫码', '新增', '导入']
  const [qrCode, setQrCode] = useState({})
  const [qrCodeShow, setQrCodeShow] = useState(false) //  表格加载状态
  const channelList = [{ label: '自访', value: '自访' },
    { label: '武房通', value: '武房通' },
    { label: '路过', value: '路过' },
    { label: '抖音直播', value: '抖音直播' },
    { label: '腾讯大v', value: '腾讯大v' },
    { label: '安居客', value: '安居客' },
    { label: '分销', value: '分销' },
    { label: '员工推荐', value: '员工推荐' },
    { label: '朋友介绍', value: '朋友介绍' },
    { label: '同行转介', value: '同行转介' },
    { label: '派单', value: '派单' },
    { label: '电梯框架', value: '电梯框架' },
    { label: '公交车身', value: '公交车身' },
    { label: '公交站牌', value: '公交站牌' },
  ]
  const [visitorModal, setVisitorModal] = useState(false) //  新增访客弹窗
  const initVisitorInfo = {
    mobile: '',
    trueName: '',
    channelName: '',
    customerLevel: '',
    visiteNum: 1,
    followUpUserId: null,
    firstVisitTime: '',
    remark: '',
  }
  const [visitorForm] = Form.useForm()
  const [visitorInfo, setVisitorInfo] = useState({
    id: 0,
    mobile: '',
  })
  const [followUpUserList, setFollowUpUserList] = useState([]) // 全部跟进人列表

  const [allocationLoading, setAllocationLoading] = useState(false) //  分配状态
  const [followUpUserModal, setFollowUpUserModal] = useState(false) //  跟进人列表弹窗
  const [allocationForm, setAllocationForm] = useState({
    originFollowUpUserId: 0, //	跟进人编号
    userId: 0, //	被分配用户编号
    followUpUserId: 0, //	跟进人编号
    followUpType: 0 //	分配状态；0：跟进人置空；1：分配跟进人
  })
  //  获取跟进人列表
  const fetchData = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    setListLoading(true)
    const res = await getHouseVisitorListAPI(listQuery)
    if (res.success === true) {
      if (res.result.list) {
        res.result.list.forEach((item, index) => {
          item.sourceTypeTxt = sourceTypeList[item.sourceType]
          item.firstVisitTime = Dayjs(item.firstVisitTime).format('YYYY-MM-DD')
          item.newVisitTime = Dayjs(item.newVisitTime).format('YYYY-MM-DD')
          item.key = index + 1
        })
      }
      setList(res.result.list)
      setTotal(res.result.total)
      setListLoading(false)
    }
  }
  //  分页变更、翻页
  const onChange = (page, pageSize) => {
    listQuery.pageInt = page
    listQuery.pageSize = pageSize
    setListQuery({
      ...listQuery,
      pageInt: page,
      pageSize: pageSize
    })
    fetchData()
  }
  //  搜索
  const searchFinish = values => {
    listQuery.mobile = values.mobile
    listQuery.channelName = values.channelName
    listQuery.pageInt = 1
    setListQuery({
      ...listQuery
    })
    fetchData()
  }
  //  获取二维码信息
  const getQRcodeInfo = async () => {
    if(!checkLogin()) {
      setTimeout(() => {
        navigate('/')
      }, 2000)
      return
    }
    const res = await getHouseVisitorQRcodeAPI()
    if (res.success === true) {
      setQrCode(res.result)
    }
  }
  //  获取全部跟进人列表
  const getAllFollowUpUserList = async () => {
    const res = await getAllFollowUpUserListAPI()
    if (res.success === true) {
      let followUpUserList = []
      res.result?.list?.forEach(item => {
        if(item.status === 1) {
          followUpUserList.push(item)
        }
      })
      setFollowUpUserList(followUpUserList)
      console.log('%c [ followUpUserList ]-142', 'font-size:13px; background:pink; color:#bf2c9f;', followUpUserList)
    }
  }
  //  显示、隐藏二维码
  const showQRcode = (status) => {
    setQrCodeShow(status)
  }
  //  二维码配置
  const setQrCodeConfig = async (values) => {
    console.log(values)
    let params = {
      ...qrCode,
      ...values
    }
    const res = await configHouseVisitorQRcodeAPI(params)
    if (res.success === true) {
      message.success(res.message || '配置成功')
      setQrCode({
        ...qrCode,
        ...values
      })
    } else {
      message.error(res.message || '配置失败')
    }
  }
  //  访客弹窗显示
  const showEditVisitorModal = (values) => {
    if(values.id) {
      visitorForm.setFieldsValue({
        id: values.id,
        mobile: values.mobile,
        trueName: values.trueName,
        channelName: values.channelName,
        customerLevel: values.customerLevel,
        visiteNum: values.visiteNum,
        followUpUserId: values.followUpUserId || 0,
        firstVisitTime: values.firstVisitTime ? Dayjs(values.firstVisitTime) : '',
        remark: values.remark || '',
      })
      setVisitorInfo({
        id: values.id,
        mobile: values.mobile,
      })
    } else {
      visitorForm.resetFields();
      setVisitorInfo({
        id: 0,
        mobile: '',
      })
    }
    setVisitorModal(true)
  }
  //  新增跟进人
  const visitorFinish = async (values) => {
    if(!checkPhone(values.mobile) && visitorInfo.id === 0) {
      message.error('手机号格式不正确')
      return
    }
    values.visiteNum = Number(values.visiteNum)
    if(values.visiteNum <= 0) {
      message.error('访问次数不能小于等于0')
      return
    }
    values.firstVisitTime = values.firstVisitTime ? Dayjs(values.firstVisitTime).format('YYYY-MM-DD') : ''
    if(!values.firstVisitTime) {
      message.error('请选择首次访问时间')
      return
    }
    values.followUpUserId = values.followUpUserId || 0
    if(values.id) {
      addHouseVisitor(values)
    } else {
      editHouseVisitor(values)
    }
    
  }
  //  新增访客
  const addHouseVisitor = async (values) => {
    const res = await addHouseVisitorAPI(values)
    if (res.success === true) {
      message.success(res.message || '新增成功')
      fetchData()
      setVisitorModal(false)
      visitorForm.resetFields();
    } else {
      message.error(res.message || '新增失败')
    }
  }
  //  编辑访客
  const editHouseVisitor = async (values) => {
    const res = await updateHouseVisitorAPI({...values, id: visitorInfo.id})
    if (res.success === true) {
      message.success(res.message || '编辑成功')
      fetchData()
      setVisitorInfo({
        id: 0,
        mobile: '',
      })
      setVisitorModal(false)
      visitorForm.resetFields();
    } else {
      message.error(res.message || '编辑失败')
    }
  }
  //  显示跟进人弹窗
  const showFollowUpUserModal = (user) => {
    console.log('%c [ user ]-221', 'font-size:13px; background:pink; color:#bf2c9f;', user)
    let allocationForm = {
      originFollowUpUserId: user.followUpUserId || 0,
      userId: user.userId,
      followUpUserId: user.followUpUserId || 0,
      type: 0,
    }
    setAllocationForm(allocationForm)
    setFollowUpUserModal(true)
  }
  //  分客
  const allocationFollowUpUser = () => {
    setAllocationLoading(true)
    if(allocationForm.type == 0 && allocationForm.originFollowUpUserId == allocationForm.followUpUserId) {
      message.error('跟进人未变更')
      return false
    }
    
    let params = {
      userId: allocationForm.userId, 
      followUpUserId: allocationForm.followUpType === 0 ? allocationForm.originFollowUpUserId : allocationForm.followUpUserId,
      followUpType: allocationForm.followUpType || 0
    }
    allocationCustomerAPI(params).then((res) => {
      if (res.success === true) {
        message.success(res.message || '分配成功')
        fetchData()
        getAllFollowUpUserList()
        setFollowUpUserModal(false)
      } else {
        message.error(res.message)
      }
      setAllocationLoading(false)
    })
  }
  //  变更分配的跟进人
  const changeAllocationFollowUpUser = (e) => {
    setAllocationForm({
      ...allocationForm,
      followUpUserId: e,
      followUpType: e === 0 ? 0 : 1
    })
  }

  useEffect(() => {
    if(!checkMenu(location.pathname)) {
      navigate('/managecenter/404')
      return
    }
    fetchData()
    getQRcodeInfo()
    getAllFollowUpUserList()
  }, [])
  return (
    <div>
      <div className="pageTitle flex-between">
        <div className="pageTitle-name">案场来访登记</div>
        <div className="pageTitle-desc flex align-items cursor-pointer" onClick={() => showQRcode(true)}>
          <QrcodeOutlined />
          <div className="margin-left-10">我的案场登记码</div>
        </div>
      </div>
      <Card className="card">
        <div className="flex-between">
          <Form initialValues={listQuery} onFinish={searchFinish} className="searchForm">
            <Form.Item name="mobile">
              <Input allowClear placeholder="手机号" style={{ width: '200px' }} />
            </Form.Item>
            <Form.Item name="channelName">
              <Input allowClear placeholder="来访渠道" style={{ width: '200px', marginLeft: '10px' }} />
            </Form.Item>
            <Form.Item>
              <Button type="primary" className="searchBtn" htmlType="submit" style={{ marginLeft: '10px' }}>
                搜索
              </Button>
            </Form.Item>
          </Form>
        </div>
        {/* <div className='bg-fafafa padding-left-24 padding-right-24 line-height-40 flex-end font-size14 margin-bottom-12'>
          <div className='flex-end cursor-pointer' onClick={() => showEditVisitorModal({})}>
            <PlusOutlined />
            <div className='margin-left-10'>新增</div>
          </div>
          <div className='flex-end margin-left-24 cursor-pointer'>
            <UploadOutlined />
            <div className='margin-left-10'>导入</div>
          </div>
        </div> */}
        <Table dataSource={list} loading={listLoading} pagination={false}>
          <Column title="昵称" dataIndex="nickname" />
          <Column title="客户姓名" dataIndex="trueName" />
          <Column title="手机号" dataIndex="mobile" />
          <Column title="来访渠道" dataIndex="channelName" />
          <Column title="客户级别" dataIndex="customerLevel" />
          <Column title="来访次数" dataIndex="visiteNum" />
          <Column title="跟进人" dataIndex="followUpNickName" />
          <Column title="备注" dataIndex="remark" />
          <Column title="来源" dataIndex="sourceTypeTxt" />
          <Column title="首次到访" dataIndex="firstVisitTime" />
          <Column title="最新到访" dataIndex="newVisitTime" />
          <Column
            title="操作"
            key="action"
            width={220}
            render={(_, record) => (
              <Space size="middle">
                <Button type="link" className="color-576b95" onClick={() => showEditVisitorModal(record)}>编辑</Button>
                {record.userId ? <Link target="_blank" to={'/managecenter/user/detail/' + record.userId} className="color-576b95">画像</Link> : ''}
                {record.userId ? <Button type="link" className="color-576b95" onClick={() => showFollowUpUserModal(record)}>分客</Button> : ''}
              </Space>
            )}
          />
        </Table>
        <Pagination hideOnSinglePage defaultPageSize={20} showTotal={total => '共 ' + total + ' 条数据'} pageSize={listQuery.pageSize} pageSizeOptions={['10', '20', '30', '50', '100']} total={total} showSizeChanger showQuickJumper onChange={onChange} />
      </Card>
      <Modal title="" closable={false} open={qrCodeShow} footer={null} onCancel={() => showQRcode(false)}>
        <div className="font-size16" style={{width: '480px'}}>
          <div className="flex-between line-height-24">
            <div className="font-weight-600">案场登记二维码：{qrCode.houseName}</div>
            <div className="color-999999 cursor-pointer" onClick={() => showQRcode(false)}>关闭</div>
          </div>
          <div className="margin-top-24 line-height-24">将二维码下载保存，通过手机、海报、大屏等，在案场让来访顾客进行扫描</div>
          {qrCode.qrcodeUrl ? (
            <div>
              <div className="margin-top-24 flex-center">
                <Image src={qrCode.qrcodeUrl} style={{ width: '260px', height: '260px' }} />
              </div>
              <div className="margin-top-24 line-height-24 align-center">右键下载保存</div>
              <div className="margin-top-24 flex-center">
                <div className="font-size16">落地页展示接待人</div>
                <Select value={qrCode.showBoss} options={[{label: '是', value: true}, {label: '否', value: false}]} placeholder="是否展示接待人" className="margin-left-12" style={{ width: '120px' }} onChange={(value) => setQrCodeConfig({ showBoss: value })} />
              </div>
              <div className="margin-top-24 flex-center">
                <div className="font-size16">推送到置业顾问端</div>
                <Select value={qrCode.pushBossStatus} options={[{label: '是', value: true}, {label: '否', value: false}]} placeholder="是否推送到置业顾问端" className="margin-left-12" style={{ width: '120px' }} onChange={(value) => setQrCodeConfig({ pushBossStatus: value })} />
              </div>
            </div>
          ) : <div className="line-height-24 align-center" style={{ padding: '140px 0' }}>暂无二维码，请联系管理员</div>}
          
        </div>
      </Modal>
      <Modal title="" closable={true} open={visitorModal} footer={null} onCancel={() => setVisitorModal(false)}>
        <div className="padding-top-32" style={{width: '430px'}}>
          <Form form={visitorForm} labelCol={{ span: 4 }} initialValues={initVisitorInfo} onFinish={visitorFinish}>
            {visitorInfo.id > 0 ? <div className="font-weight-600 line-height-32 font-size24 margin-bottom-32">来访客户：{visitorInfo.mobile}</div> : (
              <Form.Item label="手机号" name="mobile">
                <Input allowClear placeholder="必填，11位数字" />
              </Form.Item>
            )}
            <Form.Item label="客户姓名" name="trueName">
              <Input allowClear placeholder="1-10字" />
            </Form.Item>
            <Form.Item label="来访渠道" name="channelName">
              <Select allowClear options={channelList} placeholder="选择来访渠道" />
            </Form.Item>
            <Form.Item label="客户级别" name="customerLevel">
              <Select allowClear options={[{label: 'A', value: 'A'}, {label: 'B', value: 'B'}, {label: 'C', value: 'C'}]} placeholder="选择客户级别" />
            </Form.Item>
            <Form.Item label="来访次数" name="visiteNum">
              <Input type="number" placeholder="来访次数" />
            </Form.Item>
            <Form.Item label="置业顾问" name="followUpUserId">
              <Select allowClear options={ followUpUserList.map(item => ({ label: item.nickName, value: item.userId })) } placeholder="选择置业顾问" />
            </Form.Item>
            <Form.Item label="首访到访" name="firstVisitTime">
              <DatePicker format="YYYY-MM-DD" className="width-100" />
            </Form.Item>
            <Form.Item label="备注" name="remark">
              <TextArea rows={4} placeholder="0-300字" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" className="searchBtn" htmlType="submit">保存</Button>
              <Button type="primary" className="searchBtn" htmlType="reset" onClick={() => { visitorForm.resetFields(); setVisitorModal(false); }} style={{ marginLeft: '10px' }}>取消</Button>
            </Form.Item>
          </Form>
        </div>
      </Modal>
      <Modal title="分客" closable={false} open={followUpUserModal} onOk={allocationFollowUpUser} onCancel={() => setFollowUpUserModal(false)} footer={[
          <Button key="back" onClick={() => setFollowUpUserModal(false)}>取消</Button>,
          <Button key="submit" type="primary" loading={allocationLoading} onClick={allocationFollowUpUser}>确定</Button>
        ]}>
        <div className={styles['followUpUser-item']}>
          <div className={styles['info']}>
            <div className={styles['name']}>置空跟进人</div>
          </div>
          <div className={styles['checkbox']}>
            <Checkbox checked={allocationForm.followUpUserId === 0} onChange={() => changeAllocationFollowUpUser(0)} />
          </div>
        </div>
        {followUpUserList.map((item, index) => {
          return (
            <div className={styles['followUpUser-item']} key={index}>
              <div className={styles['info']}>
                <Avatar shape="square" size={24} draggable={false} src={item.avatarUrl} />
                <div className={styles['name']}>{item.nickName}</div>
                {(item.customerNum - item.labelNum) >= item.allowNoLabelUserNum && <div className={styles['label']}>分配受限</div>}
              </div>
              <Checkbox checked={item.userId === allocationForm.followUpUserId} disabled={(item.customerNum - item.labelNum) >= item.allowNoLabelUserNum} onChange={() => changeAllocationFollowUpUser(item.userId)} />
            </div>
          )
        })}
      </Modal>
    </div>
  )
}
